import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { handleError } from "../../../shared/functions/handleError";
import { IVersionAction } from "../../../shared/interfaces/version/IVersion";
import { VersionService } from "../service";
import VersionForm from "./VersionForm";

const versionItemSchema = yup.object({
  title: yup.string().required(),
  text: yup.string().required(),
});

export const versionSchema = yup.object({
  version: yup.string().required(),
  items: yup.array().of(versionItemSchema).required(),
  isActive: yup.boolean().required(),
});

const VersionCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control } = useForm<IVersionAction>({
    resolver: yupResolver(versionSchema) as unknown as Resolver<IVersionAction>,
    defaultValues: {
      isActive: false,
      items: [{ title: "", text: "" }],
    },
  });

  const submitHandler = (formData: IVersionAction) => {
    VersionService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyCreated", { title: formData?.version }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <VersionForm control={control} />
    </form>
  );
};

export default VersionCreate;
